module.exports = __webpack_public_path__ + "static/media/illustration-homepage.16610c47.svg";